import React from 'react';
import PropTypes from 'prop-types';
import { IndexLink, Link } from 'react-router';
import SportingLifeLogo from 'modules/Common/components/svg/SportingLifeLogo';

const Footer = ({ handleOpenFeedbackForm, handleScrollTop }) => (
    <footer className="footer">
        <div className="footer__top-wrapper">
            <div className="footer__top">
                <div className="footer__icon">
                    <IndexLink to="/" className="svg-fix">
                        <SportingLifeLogo/>
                    </IndexLink>
                </div>
                <div className="footer__scroll-top">
                    <a href="#" onClick={e => handleScrollTop(e)}>Top <i className="i" data-char={"\uF023"} /></a>
                </div>
            </div>
        </div>
        <div className="footer__bottom-wrapper">
            <div className="footer__bottom">
                <div className="footer__links">
                    <span><a id="contactus" href="mailto:feedback@sportinglife.com">Contact Us</a></span>
                    <span><a href="#feedback" onClick={handleOpenFeedbackForm}>Feedback</a></span>
                    <span><Link to="/privacy" title="Privacy and Cookie Notice">Privacy and Cookie Notice</Link></span>
                </div>
                <div className="footer__copy">
                    &copy; {new Date().getFullYear()} Hestview Ltd. All Rights Reserved.
                </div>
            </div>
        </div>
    </footer>
);

Footer.propTypes = {
    handleOpenFeedbackForm: PropTypes.func.isRequired,
    handleScrollTop: PropTypes.func.isRequired
};

export default Footer;



// WEBPACK FOOTER //
// ./modules/Common/components/Footer.js